import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { config } from './config';
import ProtectedRoute from './components/ProtectedRoute';
import UnderConstruction from './components/UnderConstruction/UnderConstruction';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home/Home';
import Pricing from './pages/Pricing/Pricing';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import Dashboard from './pages/Dashboard/Dashboard';
import './App.scss';

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <Router>
                    <div className="app">
                        <Header />
                        {config.SHOW_UNDER_CONSTRUCTION && <UnderConstruction />}
                        <main className="app__main">
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/features" element={<div className="placeholder-page">Features Page Coming Soon</div>} />
                                <Route path="/about" element={<div className="placeholder-page">About Page Coming Soon</div>} />
                                <Route path="/pricing" element={<Pricing />} />
                                <Route path="/contact" element={<div className="placeholder-page">Contact Page Coming Soon</div>} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/signup" element={<Signup />} />
                                <Route path="/dashboard" element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                } />
                                <Route path="/settings" element={
                                    <ProtectedRoute>
                                        <div className="placeholder-page">Settings Page Coming Soon</div>
                                    </ProtectedRoute>
                                } />
                                <Route path="/forgot-password" element={<div className="placeholder-page">Forgot Password Page Coming Soon</div>} />
                                <Route path="/terms" element={<div className="placeholder-page">Terms of Service Coming Soon</div>} />
                                <Route path="/privacy" element={<div className="placeholder-page">Privacy Policy Coming Soon</div>} />
                            </Routes>
                        </main>
                        <Footer />
                    </div>
                </Router>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
